import { goodDataSettingsSource } from 'app.constants';
import { BaseAnalyticsController } from '../base/BaseAnalyticsController';
export class GoodDataController extends BaseAnalyticsController {
    constructor() {
        super(...arguments);
        this.settingsSource = goodDataSettingsSource;
    }
}
